var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-container" }, [
    _c("header", [
      _vm.title
        ? _c("h3", { staticClass: "c-form-container__title" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.showProgressBar && (_vm.steps && _vm.steps.length)
      ? _c(
          "div",
          { staticClass: "c-form-container__progress" },
          [
            _c("progress-step-bar", {
              attrs: { currentStep: _vm.currentStep, steps: _vm.steps }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("form", { staticClass: "c-form-container__form" }, [
      _c(
        "section",
        { staticClass: "c-form-container__form--section" },
        [_vm._t("default")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4924040b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4924040b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/forms/form-container/form-container.vue
// module id = 675
// module chunks = 0